import React from 'react'
import PropTypes from 'prop-types'

import './TimeIndicator.scss'
import formatSeconds from './formatSeconds'

const TimeIndicator = ({currentTime, totalTime}) => (
  <span styleName="time-indicator" tabIndex={0}>
    {`${formatSeconds(currentTime)}/${formatSeconds(totalTime)}`}
  </span>
)

TimeIndicator.propTypes = {
  currentTime: PropTypes.number.isRequired,
  totalTime: PropTypes.number.isRequired
}

export default TimeIndicator
